export enum RegisterType {
	ELECTRICITY_DAY = 'ELECTRICITY_DAY',
	ELECTRICITY_NIGHT = 'ELECTRICITY_NIGHT',
	ELECTRICITY_EX_NIGHT = 'ELECTRICITY_EX_NIGHT',
	ELECTRICITY_DAY_PLUS = 'ELECTRICITY_DAY_PLUS',
	ELECTRICITY_NIGHT_PLUS = 'ELECTRICITY_NIGHT_PLUS',
	ELECTRICITY_DAY_MIN = 'ELECTRICITY_DAY_MIN',
	ELECTRICITY_NIGHT_MIN = 'ELECTRICITY_NIGHT_MIN',
	GAS = 'GAS',
}
